import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { FocusRemoverDirective } from '@helper/focus-remover.directive';

@Component({
  selector: 'app-maintain',
  templateUrl: './maintain.component.html',
  styleUrls: ['./maintain.component.scss'],
  imports: [MatDialogModule, FocusRemoverDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintainComponent {
  static dialogId = 'maintain_dialog';

  static open(dialog: MatDialog): MatDialogRef<unknown> | undefined {
    if (dialog.getDialogById(MaintainComponent.dialogId)) {
      return undefined;
    }
    return dialog.open(MaintainComponent, {
      id: MaintainComponent.dialogId,
      width: '270px',
      disableClose: false,
    });
  }
}
